import bbox from '@turf/bbox';
import { lineString } from '@turf/helpers';
import chunk from 'lodash/chunk';
import { WebMercatorViewport } from 'react-map-gl';
import theme from './theme';
export const getMapCenterAndZoom = (coordinates, mapWidth, isSummaryMap) => {
    if (Array.isArray(coordinates)) {
        const { width, height } = getMapWidthAndHeight(mapWidth);
        return getMapCenterAndZoomByBoundingBox(coordinates, width, height, isSummaryMap);
    }
    else {
        return getMapCenterAndZoomByCoordinate(coordinates);
    }
};
const getMapCenterAndZoomByCoordinate = (coordinate) => {
    return {
        center: coordinate,
        zoom: 7,
    };
};
export const getMapCenterAndZoomByBoundingBox = (coordinates, width, height, isSummaryMap) => {
    // maps the coordinates to lng lat pairs usable in the geojson spec.
    const markerCoords = coordinates.map((coord) => [
        coord.lng,
        coord.lat,
    ]);
    const fallBackSettings = {
        center: coordinates[0] ? coordinates[0] : { lat: 52.5, lng: 13.4 },
        zoom: 7,
    };
    if (coordinates.length <= 1) {
        // If there are no coordinates supplied, or not enough to create a proper boundingbox
        // we can simply return the fallback settings which centers on the first coordinate or a fallback coord.
        return fallBackSettings;
    }
    // Uses turf to define a bounding box of all the available coordinates
    const geoJsonLine = lineString(markerCoords);
    const boundingBox = bbox(geoJsonLine);
    // Given the boundingbox and a width/height it returns a center location and zoom level.
    try {
        const { latitude, longitude, zoom } = new WebMercatorViewport({
            width,
            height,
        }).fitBounds([
            [boundingBox[0], boundingBox[1]],
            [boundingBox[2], boundingBox[3]],
        ], {
            // On larger maps the padding can be larger for a pleasant view.
            // On mobile, we use the paddingTop to ensure that the locations are not under the title breadcrumb and under the steps indicators on the map.
            padding: height <= theme.distances.mobileMapHeight
                ? { top: isSummaryMap ? 60 : 135, bottom: 50, left: 50, right: 50 }
                : 200,
        });
        return {
            center: { lat: latitude, lng: longitude },
            zoom: Math.max(zoom, 0),
        };
    }
    catch (_a) {
        // Fallback which returns the fist coordinate as starting position,
        // in some cases the width / height might not be supplied right away when rendering.
        // In that case this fallback will trigger to prevent any runtime errors
        return fallBackSettings;
    }
};
const getMapWidthAndHeight = (mapWidth) => {
    return { width: mapWidth, height: theme.distances.mobileMapHeight };
};
export const numberArrayToCoordinates = (numbers) => {
    if (numbers.length % 2 !== 0) {
        // Uneven array, so we can't make pairs correctly.
        return [];
    }
    const pairs = chunk(numbers, 2);
    return pairs.map((pair) => {
        return { lat: pair[1], lng: pair[0] };
    });
};
export const createGeoJSONfromCommunities = (communities) => {
    const geojson = {
        name: 'Communities',
        type: 'FeatureCollection',
        features: communities.map(({ locationLongitude, locationLatitude, id, name }) => ({
            type: 'Feature',
            geometry: {
                type: 'Symbol',
                coordinates: [locationLongitude, locationLatitude],
            },
            properties: {
                communityId: id,
                name,
            },
        })),
    };
    return geojson;
};
export const createGeoJSONfromSiteCluster = (sites) => {
    const geojson = {
        name: 'FarmCluster',
        type: 'FeatureCollection',
        features: sites.map(({ locationCoordinates, id, title }) => ({
            type: 'Feature',
            geometry: {
                type: 'Symbol',
                coordinates: [locationCoordinates.lng, locationCoordinates.lat],
            },
            properties: {
                siteId: id,
                title,
            },
        })) || [],
    };
    return geojson;
};
